// extracted by mini-css-extract-plugin
export default {"h50px":"Modal_3_1_WriteArticle_h50px__I4JSv"};